export const afip = [
  { id: 'CF', name: 'Consumidor Final' },
  { id: 'RI', name: 'Responsable Inscripto' },
  { id: 'RM', name: 'Responsable Monotributo' },
  { id: 'SE', name: 'Sujeto Exento' },
];

export const provinces = [
  { id: 1, name: 'Buenos Aires' },
  { id: 2, name: 'Catamara' },
  { id: 16, name: 'Chaco' },
  { id: 17, name: 'Chubut' },
  { id: 0, name: 'Ciudad Autónoma de Buenos Aires' },
  { id: 4, name: 'Corrientes' },
  { id: 3, name: 'Córdoba' },
  { id: 5, name: 'Entre Ríos' },
  { id: 18, name: 'Formosa' },
  { id: 6, name: 'Jujuy' },
  { id: 21, name: 'La Pampa' },
  { id: 8, name: 'La Rioja' },
  { id: 7, name: 'Mendoza' },
  { id: 19, name: 'Misiones' },
  { id: 20, name: 'Neuquén' },
  { id: 22, name: 'Río Negro' },
  { id: 9, name: 'Salta' },
  { id: 10, name: 'San Juan' },
  { id: 11, name: 'San Luis' },
  { id: 23, name: 'Santa Cruz' },
  { id: 12, name: 'Santa Fe' },
  { id: 13, name: 'Santiago del Estero' },
  { id: 24, name: 'Tierra del Fuego' },
  { id: 14, name: 'Tucumán' },
];

export const cities = [
  {
    id: 43289,
    label: 'Villa Carlos Paz, Córdoba, Argentina',
  },
  {
    id: 43202,
    label: 'Córdoba, Córdoba, Argentina',
  },
  {
    id: 43401,
    label: 'Villa Maria, Córdoba, Argentina',
  },
  {
    id: 43406,
    label: 'Ascochinga, Córdoba, Argentina',
  },
  {
    id: 43408,
    label: 'Traslasierra, Córdoba, Argentina',
  },
  {
    id: 43418,
    label: 'San Javier, Córdoba, Argentina',
  },
  {
    id: 43425,
    label: 'Los Molinos, Córdoba, Argentina',
  },
  {
    id: 43433,
    label: 'Bialet Masse, Córdoba, Argentina',
  },
  {
    id: 43436,
    label: 'Huerta Grande, Córdoba, Argentina',
  },
  {
    id: 43443,
    label: 'San Pedro Norte, Córdoba, Argentina',
  },
  {
    id: 43457,
    label: 'Rio Ceballos, Córdoba, Argentina',
  },
  {
    id: 43468,
    label: 'Villa Giardino, Córdoba, Argentina',
  },
  {
    id: 43473,
    label: 'Santa Catalina, Córdoba, Argentina',
  },
  {
    id: 43474,
    label: 'La Cumbrecita, Córdoba, Argentina',
  },
  {
    id: 43477,
    label: 'Las Lajas, Córdoba, Argentina',
  },
  {
    id: 43478,
    label: 'Tanti, Córdoba, Argentina',
  },
  {
    id: 43480,
    label: 'Icho Cruz, Córdoba, Argentina',
  },
  {
    id: 43487,
    label: 'Villa Cura Brochero, Córdoba, Argentina',
  },
  {
    id: 43489,
    label: 'Pampa de Achala, Córdoba, Argentina',
  },
  {
    id: 43491,
    label: 'Cabalango, Córdoba, Argentina',
  },
  {
    id: 43500,
    label: 'La Cumbre, Córdoba, Argentina',
  },
  {
    id: 43517,
    label: 'Río Tercero, Córdoba, Argentina',
  },
  {
    id: 43518,
    label: 'Capilla del Monte, Córdoba, Argentina',
  },
  {
    id: 43523,
    label: 'Villa Belgrano, Córdoba, Argentina',
  },
  {
    id: 43529,
    label: 'Morteros, Córdoba, Argentina',
  },
  {
    id: 43545,
    label: 'Embalse, Córdoba, Argentina',
  },
  {
    id: 43552,
    label: 'Laboulaye, Córdoba, Argentina',
  },
  {
    id: 43591,
    label: 'San Francisco, Córdoba, Argentina',
  },
  {
    id: 43599,
    label: 'Villa La Serranita, Córdoba, Argentina',
  },
  {
    id: 43607,
    label: 'San Miguel, Córdoba, Argentina',
  },
  {
    id: 43610,
    label: 'Adelia María, Córdoba, Argentina',
  },
  {
    id: 43614,
    label: 'Valle de Ongamira, Córdoba, Argentina',
  },
  {
    id: 43616,
    label: 'Devoto, Córdoba, Argentina',
  },
  {
    id: 43619,
    label: 'Villa Allende, Córdoba, Argentina',
  },
  {
    id: 43629,
    label: 'Villa del Rosario, Córdoba, Argentina',
  },
  {
    id: 43640,
    label: 'Oncativo, Córdoba, Argentina',
  },
  {
    id: 43641,
    label: 'Isla Verde, Córdoba, Argentina',
  },
  {
    id: 43966,
    label: 'Caleta Córdoba, Córdoba, Argentina',
  },
];

export const countries = [
  {
    id_country: 11,
    name: 'Argentina',
    code_nemo: 'AR',
    code_journeys: '',
  },
  {
    id_country: 1,
    name: 'Afganistan',
    code_nemo: 'AF',
    code_journeys: '',
  },
  {
    id_country: 2,
    name: 'Albania',
    code_nemo: 'AL',
    code_journeys: '',
  },
  {
    id_country: 3,
    name: 'Alemania',
    code_nemo: 'DE',
    code_journeys: '',
  },
  {
    id_country: 4,
    name: 'Andorra',
    code_nemo: 'AD',
    code_journeys: '',
  },
  {
    id_country: 5,
    name: 'Angola',
    code_nemo: 'AO',
    code_journeys: '',
  },
  {
    id_country: 6,
    name: 'Anguila',
    code_nemo: 'AI',
    code_journeys: '',
  },
  {
    id_country: 7,
    name: 'Antigua y Barbuda',
    code_nemo: 'AG',
    code_journeys: '',
  },
  {
    id_country: 8,
    name: 'Antillas Holandesas',
    code_nemo: 'AN',
    code_journeys: '',
  },
  {
    id_country: 9,
    name: 'Arabia Saudita',
    code_nemo: 'SA',
    code_journeys: '',
  },
  {
    id_country: 10,
    name: 'Argelia',
    code_nemo: 'DZ',
    code_journeys: '',
  },
  {
    id_country: 12,
    name: 'Armenia',
    code_nemo: 'AM',
    code_journeys: '',
  },
  {
    id_country: 13,
    name: 'Aruba',
    code_nemo: 'AW',
    code_journeys: '',
  },
  {
    id_country: 14,
    name: 'Australia',
    code_nemo: 'AU',
    code_journeys: '',
  },
  {
    id_country: 15,
    name: 'Austria',
    code_nemo: 'AT',
    code_journeys: '',
  },
  {
    id_country: 16,
    name: 'Azerbaiyn',
    code_nemo: 'AZ',
    code_journeys: '',
  },
  {
    id_country: 17,
    name: 'Bahamas',
    code_nemo: 'BS',
    code_journeys: '',
  },
  {
    id_country: 18,
    name: 'Bahrin',
    code_nemo: 'BH',
    code_journeys: '',
  },
  {
    id_country: 19,
    name: 'Bangladesh',
    code_nemo: 'BD',
    code_journeys: '',
  },
  {
    id_country: 20,
    name: 'Barbados',
    code_nemo: 'BB',
    code_journeys: '',
  },
  {
    id_country: 21,
    name: 'Belars',
    code_nemo: 'BY',
    code_journeys: '',
  },
  {
    id_country: 22,
    name: 'Belice',
    code_nemo: 'BZ',
    code_journeys: '',
  },
  {
    id_country: 23,
    name: 'Benn',
    code_nemo: 'BJ',
    code_journeys: '',
  },
  {
    id_country: 24,
    name: 'Bermudas',
    code_nemo: 'BM',
    code_journeys: '',
  },
  {
    id_country: 25,
    name: 'Bhutn',
    code_nemo: 'BT',
    code_journeys: '',
  },
  {
    id_country: 26,
    name: 'Blgica',
    code_nemo: 'BE',
    code_journeys: '',
  },
  {
    id_country: 27,
    name: 'Bolivia',
    code_nemo: 'BO',
    code_journeys: '',
  },
  {
    id_country: 28,
    name: 'Bosnia y Herzegovina',
    code_nemo: 'BA',
    code_journeys: '',
  },
  {
    id_country: 29,
    name: 'Botsuana',
    code_nemo: 'BW',
    code_journeys: '',
  },
  {
    id_country: 30,
    name: 'Brasil',
    code_nemo: 'BR',
    code_journeys: 'BRA',
  },
  {
    id_country: 31,
    name: 'Bruni',
    code_nemo: 'BN',
    code_journeys: '',
  },
  {
    id_country: 32,
    name: 'Bulgaria',
    code_nemo: 'BG',
    code_journeys: '',
  },
  {
    id_country: 33,
    name: 'Burkina Faso',
    code_nemo: 'BF',
    code_journeys: '',
  },
  {
    id_country: 34,
    name: 'Burundi',
    code_nemo: 'BI',
    code_journeys: '',
  },
  {
    id_country: 35,
    name: 'Cabo Verde, República de',
    code_nemo: 'CV',
    code_journeys: '',
  },
  {
    id_country: 36,
    name: 'Camboya',
    code_nemo: 'KH',
    code_journeys: '',
  },
  {
    id_country: 37,
    name: 'Camern, República de',
    code_nemo: 'CM',
    code_journeys: '',
  },
  {
    id_country: 38,
    name: 'Canad',
    code_nemo: 'CA',
    code_journeys: '',
  },
  {
    id_country: 39,
    name: 'Chad',
    code_nemo: 'TD',
    code_journeys: '',
  },
  {
    id_country: 40,
    name: 'Chile',
    code_nemo: 'CL',
    code_journeys: '',
  },
  {
    id_country: 41,
    name: 'China',
    code_nemo: 'CN',
    code_journeys: '',
  },
  {
    id_country: 42,
    name: 'Chipre',
    code_nemo: 'CY',
    code_journeys: '',
  },
  {
    id_country: 43,
    name: 'Colombia',
    code_nemo: 'CO',
    code_journeys: '',
  },
  {
    id_country: 44,
    name: 'Comoras',
    code_nemo: 'KM',
    code_journeys: '',
  },
  {
    id_country: 45,
    name: 'Congo',
    code_nemo: 'CG',
    code_journeys: '',
  },
  {
    id_country: 46,
    name: 'República Democrtica de Congo',
    code_nemo: 'CD',
    code_journeys: '',
  },
  {
    id_country: 47,
    name: 'Corea, República de',
    code_nemo: 'KR',
    code_journeys: '',
  },
  {
    id_country: 48,
    name: 'Corea, República Popular Democrtica de',
    code_nemo: 'KP',
    code_journeys: '',
  },
  {
    id_country: 49,
    name: 'Costa de Marfil',
    code_nemo: 'CI',
    code_journeys: '',
  },
  {
    id_country: 50,
    name: 'Costa Rica',
    code_nemo: 'CR',
    code_journeys: '',
  },
  {
    id_country: 51,
    name: 'Croacia',
    code_nemo: 'HR',
    code_journeys: '',
  },
  {
    id_country: 52,
    name: 'Cuba',
    code_nemo: 'CU',
    code_journeys: '',
  },
  {
    id_country: 53,
    name: 'Dinamarca',
    code_nemo: 'DK',
    code_journeys: '',
  },
  {
    id_country: 54,
    name: 'Dominica',
    code_nemo: 'DM',
    code_journeys: '',
  },
  {
    id_country: 55,
    name: 'Ecuador',
    code_nemo: 'EC',
    code_journeys: '',
  },
  {
    id_country: 56,
    name: 'Egipto',
    code_nemo: 'EG',
    code_journeys: '',
  },
  {
    id_country: 57,
    name: 'El Salvador',
    code_nemo: 'SV',
    code_journeys: '',
  },
  {
    id_country: 58,
    name: 'Emiratos rabes Unidos',
    code_nemo: 'AE',
    code_journeys: '',
  },
  {
    id_country: 59,
    name: 'Eritrea',
    code_nemo: 'ER',
    code_journeys: '',
  },
  {
    id_country: 60,
    name: 'Eslovaquia',
    code_nemo: 'SK',
    code_journeys: '',
  },
  {
    id_country: 61,
    name: 'Eslovenia',
    code_nemo: 'SI',
    code_journeys: '',
  },
  {
    id_country: 62,
    name: 'Espaa',
    code_nemo: 'ES',
    code_journeys: '',
  },
  {
    id_country: 63,
    name: 'Estado de la Ciudad del Vaticano',
    code_nemo: 'VA',
    code_journeys: '',
  },
  {
    id_country: 64,
    name: 'Estados Unidos',
    code_nemo: 'US',
    code_journeys: '',
  },
  {
    id_country: 65,
    name: 'Estonia',
    code_nemo: 'EE',
    code_journeys: '',
  },
  {
    id_country: 66,
    name: 'Etiopa',
    code_nemo: 'ET',
    code_journeys: '',
  },
  {
    id_country: 67,
    name: 'Federacin Rusa',
    code_nemo: 'RU',
    code_journeys: '',
  },
  {
    id_country: 68,
    name: 'Filipinas',
    code_nemo: 'PH',
    code_journeys: '',
  },
  {
    id_country: 69,
    name: 'Finlandia',
    code_nemo: 'FI',
    code_journeys: '',
  },
  {
    id_country: 70,
    name: 'Francia',
    code_nemo: 'FR',
    code_journeys: '',
  },
  {
    id_country: 71,
    name: 'Gabn',
    code_nemo: 'GA',
    code_journeys: '',
  },
  {
    id_country: 72,
    name: 'Gambia',
    code_nemo: 'GM',
    code_journeys: '',
  },
  {
    id_country: 73,
    name: 'Georgia',
    code_nemo: 'GE',
    code_journeys: '',
  },
  {
    id_country: 74,
    name: 'Ghana',
    code_nemo: 'GH',
    code_journeys: '',
  },
  {
    id_country: 75,
    name: 'Gibraltar',
    code_nemo: 'GI',
    code_journeys: '',
  },
  {
    id_country: 76,
    name: 'Granada',
    code_nemo: 'GD',
    code_journeys: '',
  },
  {
    id_country: 77,
    name: 'Grecia',
    code_nemo: 'GR',
    code_journeys: '',
  },
  {
    id_country: 78,
    name: 'Groenlandia',
    code_nemo: 'GL',
    code_journeys: '',
  },
  {
    id_country: 79,
    name: 'Guadalupe',
    code_nemo: 'GP',
    code_journeys: '',
  },
  {
    id_country: 80,
    name: 'Guam',
    code_nemo: 'GU',
    code_journeys: '',
  },
  {
    id_country: 81,
    name: 'Guatemala',
    code_nemo: 'GT',
    code_journeys: '',
  },
  {
    id_country: 82,
    name: 'Guinea',
    code_nemo: 'GN',
    code_journeys: '',
  },
  {
    id_country: 83,
    name: 'Guinea Bissau',
    code_nemo: 'GW',
    code_journeys: '',
  },
  {
    id_country: 84,
    name: 'Guinea Ecuatorial',
    code_nemo: 'GQ',
    code_journeys: '',
  },
  {
    id_country: 85,
    name: 'Guyana',
    code_nemo: 'GY',
    code_journeys: '',
  },
  {
    id_country: 86,
    name: 'Guyana Francesa',
    code_nemo: 'GF',
    code_journeys: '',
  },
  {
    id_country: 87,
    name: 'Hait',
    code_nemo: 'HT',
    code_journeys: '',
  },
  {
    id_country: 88,
    name: 'Honduras',
    code_nemo: 'HN',
    code_journeys: '',
  },
  {
    id_country: 89,
    name: 'Hong Kong',
    code_nemo: 'HK',
    code_journeys: '',
  },
  {
    id_country: 90,
    name: 'Hungra',
    code_nemo: 'HU',
    code_journeys: '',
  },
  {
    id_country: 91,
    name: 'India',
    code_nemo: 'IN',
    code_journeys: '',
  },
  {
    id_country: 92,
    name: 'Indonesia',
    code_nemo: 'id_country',
    code_journeys: '',
  },
  {
    id_country: 93,
    name: 'Iraq',
    code_nemo: 'IQ',
    code_journeys: '',
  },
  {
    id_country: 94,
    name: 'Irlanda, República de',
    code_nemo: 'IE',
    code_journeys: '',
  },
  {
    id_country: 95,
    name: 'Irn',
    code_nemo: 'IR',
    code_journeys: '',
  },
  {
    id_country: 96,
    name: 'Isla Ascensin/Sta. Elena',
    code_nemo: 'SH',
    code_journeys: '',
  },
  {
    id_country: 97,
    name: 'Isla Bouvet',
    code_nemo: 'BV',
    code_journeys: '',
  },
  {
    id_country: 98,
    name: 'Isla Christmas',
    code_nemo: 'CX',
    code_journeys: '',
  },
  {
    id_country: 99,
    name: 'Isla Norfolk',
    code_nemo: 'NF',
    code_journeys: '',
  },
  {
    id_country: 100,
    name: 'Islandia',
    code_nemo: 'IS',
    code_journeys: '',
  },
  {
    id_country: 101,
    name: 'Islas Caimn',
    code_nemo: 'KY',
    code_journeys: '',
  },
  {
    id_country: 102,
    name: 'Islas Cocos',
    code_nemo: 'CC',
    code_journeys: '',
  },
  {
    id_country: 103,
    name: 'Islas Cook',
    code_nemo: 'CK',
    code_journeys: '',
  },
  {
    id_country: 104,
    name: 'Islas Feroe',
    code_nemo: 'FO',
    code_journeys: '',
  },
  {
    id_country: 105,
    name: 'Islas Fiji',
    code_nemo: 'FJ',
    code_journeys: '',
  },
  {
    id_country: 106,
    name: 'Islas Malvinas',
    code_nemo: 'FK',
    code_journeys: '',
  },
  {
    id_country: 107,
    name: 'Islas Marianas',
    code_nemo: 'MP',
    code_journeys: '',
  },
  {
    id_country: 108,
    name: 'Islas Marshall',
    code_nemo: 'MH',
    code_journeys: '',
  },
  {
    id_country: 109,
    name: 'Islas menores alejadas de los Estados Unidos',
    code_nemo: 'UM',
    code_journeys: '',
  },
  {
    id_country: 110,
    name: 'Islas Salomn',
    code_nemo: 'SB',
    code_journeys: '',
  },
  {
    id_country: 111,
    name: 'Islas Seychelles',
    code_nemo: 'SC',
    code_journeys: '',
  },
  {
    id_country: 112,
    name: 'Islas Svalbard y Jan Mayen',
    code_nemo: 'SJ',
    code_journeys: '',
  },
  {
    id_country: 113,
    name: 'Islas Turcos y Caicos',
    code_nemo: 'TC',
    code_journeys: '',
  },
  {
    id_country: 114,
    name: 'Islas Vrgenes Britnicas',
    code_nemo: 'VG',
    code_journeys: '',
  },
  {
    id_country: 115,
    name: 'Islas Wallis y Futuna',
    code_nemo: 'WF',
    code_journeys: '',
  },
  {
    id_country: 116,
    name: 'Israel',
    code_nemo: 'IL',
    code_journeys: '',
  },
  {
    id_country: 117,
    name: 'Italia',
    code_nemo: 'IT',
    code_journeys: '',
  },
  {
    id_country: 118,
    name: 'Jamaica',
    code_nemo: 'JM',
    code_journeys: '',
  },
  {
    id_country: 119,
    name: 'Japn',
    code_nemo: 'JP',
    code_journeys: '',
  },
  {
    id_country: 120,
    name: 'Jordania',
    code_nemo: 'JO',
    code_journeys: '',
  },
  {
    id_country: 121,
    name: 'Kazajstn',
    code_nemo: 'KZ',
    code_journeys: '',
  },
  {
    id_country: 122,
    name: 'Kenia',
    code_nemo: 'KE',
    code_journeys: '',
  },
  {
    id_country: 123,
    name: 'Kirguistn',
    code_nemo: 'KG',
    code_journeys: '',
  },
  {
    id_country: 124,
    name: 'Kiribati',
    code_nemo: 'KI',
    code_journeys: '',
  },
  {
    id_country: 125,
    name: 'Kuwait',
    code_nemo: 'KW',
    code_journeys: '',
  },
  {
    id_country: 126,
    name: 'Laos, República Popular Democrtica de',
    code_nemo: 'LA',
    code_journeys: '',
  },
  {
    id_country: 127,
    name: 'Lbano',
    code_nemo: 'LB',
    code_journeys: '',
  },
  {
    id_country: 128,
    name: 'Lesotho',
    code_nemo: 'LS',
    code_journeys: '',
  },
  {
    id_country: 129,
    name: 'Letonia',
    code_nemo: 'LV',
    code_journeys: '',
  },
  {
    id_country: 130,
    name: 'Liberia',
    code_nemo: 'LR',
    code_journeys: '',
  },
  {
    id_country: 131,
    name: 'Liechtenstein',
    code_nemo: 'LI',
    code_journeys: '',
  },
  {
    id_country: 132,
    name: 'Lituania',
    code_nemo: 'LT',
    code_journeys: '',
  },
  {
    id_country: 133,
    name: 'Luxemburgo',
    code_nemo: 'LU',
    code_journeys: '',
  },
  {
    id_country: 134,
    name: 'Macao',
    code_nemo: 'MO',
    code_journeys: '',
  },
  {
    id_country: 135,
    name: 'Macedonia',
    code_nemo: 'MK',
    code_journeys: '',
  },
  {
    id_country: 136,
    name: 'Madagascar',
    code_nemo: 'MG',
    code_journeys: '',
  },
  {
    id_country: 137,
    name: 'Mal',
    code_nemo: 'ML',
    code_journeys: '',
  },
  {
    id_country: 138,
    name: 'Malasia',
    code_nemo: 'MY',
    code_journeys: '',
  },
  {
    id_country: 139,
    name: 'Malawi',
    code_nemo: 'MW',
    code_journeys: '',
  },
  {
    id_country: 140,
    name: 'Maldivas',
    code_nemo: 'MV',
    code_journeys: '',
  },
  {
    id_country: 141,
    name: 'Malta',
    code_nemo: 'MT',
    code_journeys: '',
  },
  {
    id_country: 142,
    name: 'Marruecos',
    code_nemo: 'MA',
    code_journeys: '',
  },
  {
    id_country: 143,
    name: 'Martinica',
    code_nemo: 'MQ',
    code_journeys: '',
  },
  {
    id_country: 144,
    name: 'Mauricio',
    code_nemo: 'MU',
    code_journeys: '',
  },
  {
    id_country: 145,
    name: 'Mauritania',
    code_nemo: 'MR',
    code_journeys: '',
  },
  {
    id_country: 146,
    name: 'Mayotte',
    code_nemo: 'YT',
    code_journeys: '',
  },
  {
    id_country: 147,
    name: 'Micronesia',
    code_nemo: 'FM',
    code_journeys: '',
  },
  {
    id_country: 148,
    name: 'Mnaco',
    code_nemo: 'MC',
    code_journeys: '',
  },
  {
    id_country: 149,
    name: 'Moldavia',
    code_nemo: 'MD',
    code_journeys: '',
  },
  {
    id_country: 150,
    name: 'Mongolia',
    code_nemo: 'MN',
    code_journeys: '',
  },
  {
    id_country: 151,
    name: 'Montenegro',
    code_nemo: 'ME',
    code_journeys: '',
  },
  {
    id_country: 152,
    name: 'Montserrat',
    code_nemo: 'MS',
    code_journeys: '',
  },
  {
    id_country: 153,
    name: 'Mozambique',
    code_nemo: 'MZ',
    code_journeys: '',
  },
  {
    id_country: 154,
    name: 'Mxico',
    code_nemo: 'MX',
    code_journeys: '',
  },
  {
    id_country: 155,
    name: 'Myanmar',
    code_nemo: 'MM',
    code_journeys: '',
  },
  {
    id_country: 156,
    name: 'Namibia',
    code_nemo: 'NA',
    code_journeys: '',
  },
  {
    id_country: 157,
    name: 'Nauru',
    code_nemo: 'NR',
    code_journeys: '',
  },
  {
    id_country: 158,
    name: 'Nepal',
    code_nemo: 'NP',
    code_journeys: '',
  },
  {
    id_country: 159,
    name: 'Nger',
    code_nemo: 'NE',
    code_journeys: '',
  },
  {
    id_country: 160,
    name: 'Nicaragua',
    code_nemo: 'NI',
    code_journeys: '',
  },
  {
    id_country: 161,
    name: 'Nigeria',
    code_nemo: 'NG',
    code_journeys: '',
  },
  {
    id_country: 162,
    name: 'Niue',
    code_nemo: 'NU',
    code_journeys: '',
  },
  {
    id_country: 163,
    name: 'Noruega',
    code_nemo: 'NO',
    code_journeys: '',
  },
  {
    id_country: 164,
    name: 'Nueva Caledonia',
    code_nemo: 'NC',
    code_journeys: '',
  },
  {
    id_country: 165,
    name: 'Nueva Zelanda',
    code_nemo: 'NZ',
    code_journeys: '',
  },
  {
    id_country: 166,
    name: 'Omn, Sultanato de',
    code_nemo: 'OM',
    code_journeys: '',
  },
  {
    id_country: 167,
    name: 'Pakistn',
    code_nemo: 'PK',
    code_journeys: '',
  },
  {
    id_country: 168,
    name: 'Palaos',
    code_nemo: 'PW',
    code_journeys: '',
  },
  {
    id_country: 169,
    name: 'Palestina',
    code_nemo: 'PS',
    code_journeys: '',
  },
  {
    id_country: 170,
    name: 'Panam',
    code_nemo: 'PA',
    code_journeys: '',
  },
  {
    id_country: 171,
    name: 'Papa Nueva Guinea (Niugini)',
    code_nemo: 'PG',
    code_journeys: '',
  },
  {
    id_country: 172,
    name: 'Paraguay',
    code_nemo: 'PY',
    code_journeys: '',
  },
  {
    id_country: 173,
    name: 'Pases Bajos',
    code_nemo: 'NL',
    code_journeys: '',
  },
  {
    id_country: 174,
    name: 'Per',
    code_nemo: 'PE',
    code_journeys: '',
  },
  {
    id_country: 175,
    name: 'Polinesia Francesa',
    code_nemo: 'PF',
    code_journeys: '',
  },
  {
    id_country: 176,
    name: 'Polonia',
    code_nemo: 'PL',
    code_journeys: '',
  },
  {
    id_country: 177,
    name: 'Portugal',
    code_nemo: 'PT',
    code_journeys: '',
  },
  {
    id_country: 178,
    name: 'Puerto Rico',
    code_nemo: '',
    code_journeys: '',
  },
  {
    id_country: 179,
    name: 'Qatar',
    code_nemo: 'QA',
    code_journeys: '',
  },
  {
    id_country: 180,
    name: 'Reino Unido',
    code_nemo: 'GB',
    code_journeys: '',
  },
  {
    id_country: 181,
    name: 'República Centroafricana',
    code_nemo: 'CF',
    code_journeys: '',
  },
  {
    id_country: 182,
    name: 'República Checa',
    code_nemo: 'CZ',
    code_journeys: '',
  },
  {
    id_country: 183,
    name: 'República Dominicana',
    code_nemo: 'DO',
    code_journeys: '',
  },
  {
    id_country: 184,
    name: 'República rabe Siria',
    code_nemo: 'SY',
    code_journeys: '',
  },
  {
    id_country: 185,
    name: 'Reunin',
    code_nemo: 'RE',
    code_journeys: '',
  },
  {
    id_country: 186,
    name: 'Ruanda',
    code_nemo: 'RW',
    code_journeys: '',
  },
  {
    id_country: 187,
    name: 'Rumana',
    code_nemo: 'RO',
    code_journeys: '',
  },
  {
    id_country: 188,
    name: 'Sahara Occidental',
    code_nemo: 'EH',
    code_journeys: '',
  },
  {
    id_country: 189,
    name: 'Samoa Americana',
    code_nemo: 'AS',
    code_journeys: '',
  },
  {
    id_country: 190,
    name: 'Samoa, Estado Independiente de',
    code_nemo: 'WS',
    code_journeys: '',
  },
  {
    id_country: 191,
    name: 'San Cristbal y Nieves',
    code_nemo: 'KN',
    code_journeys: '',
  },
  {
    id_country: 192,
    name: 'San Marino',
    code_nemo: 'SM',
    code_journeys: '',
  },
  {
    id_country: 193,
    name: 'San Pedro y Miqueln',
    code_nemo: 'PM',
    code_journeys: '',
  },
  {
    id_country: 194,
    name: 'San Vicente y las Granadinas',
    code_nemo: 'VC',
    code_journeys: '',
  },
  {
    id_country: 195,
    name: 'Santa Luca',
    code_nemo: 'LC',
    code_journeys: '',
  },
  {
    id_country: 196,
    name: 'Santo Tom y Prncipe',
    code_nemo: 'ST',
    code_journeys: '',
  },
  {
    id_country: 197,
    name: 'Senegal',
    code_nemo: 'SN',
    code_journeys: '',
  },
  {
    id_country: 198,
    name: 'Serbia',
    code_nemo: 'RS',
    code_journeys: '',
  },
  {
    id_country: 199,
    name: 'Sierra Leona',
    code_nemo: 'SL',
    code_journeys: '',
  },
  {
    id_country: 200,
    name: 'Singapur',
    code_nemo: 'SG',
    code_journeys: '',
  },
  {
    id_country: 201,
    name: 'Somalia',
    code_nemo: 'SO',
    code_journeys: '',
  },
  {
    id_country: 202,
    name: 'Sri Lanka',
    code_nemo: 'LK',
    code_journeys: '',
  },
  {
    id_country: 203,
    name: 'Suazilandia',
    code_nemo: 'SZ',
    code_journeys: '',
  },
  {
    id_country: 204,
    name: 'Sudfrica',
    code_nemo: 'ZA',
    code_journeys: '',
  },
  {
    id_country: 205,
    name: 'Sudn',
    code_nemo: 'SD',
    code_journeys: '',
  },
  {
    id_country: 206,
    name: 'Suecia',
    code_nemo: 'SE',
    code_journeys: '',
  },
  {
    id_country: 207,
    name: 'Suiza',
    code_nemo: 'CH',
    code_journeys: '',
  },
  {
    id_country: 208,
    name: 'Sum de Uzbekistn',
    code_nemo: 'UZ',
    code_journeys: '',
  },
  {
    id_country: 209,
    name: 'Surinam',
    code_nemo: 'SR',
    code_journeys: '',
  },
  {
    id_country: 210,
    name: 'Tailandia',
    code_nemo: 'TH',
    code_journeys: '',
  },
  {
    id_country: 211,
    name: 'Taiwn, República de China',
    code_nemo: 'TW',
    code_journeys: '',
  },
  {
    id_country: 212,
    name: 'Tanzania',
    code_nemo: 'TZ',
    code_journeys: '',
  },
  {
    id_country: 213,
    name: 'Tayikistn',
    code_nemo: 'TJ',
    code_journeys: '',
  },
  {
    id_country: 214,
    name: 'Timor Oriental',
    code_nemo: 'TL',
    code_journeys: '',
  },
  {
    id_country: 215,
    name: 'Tnez',
    code_nemo: 'TN',
    code_journeys: '',
  },
  {
    id_country: 216,
    name: 'Togo',
    code_nemo: 'TG',
    code_journeys: '',
  },
  {
    id_country: 217,
    name: 'Tonga',
    code_nemo: 'TO',
    code_journeys: '',
  },
  {
    id_country: 218,
    name: 'Trinidad y Tobago',
    code_nemo: 'TT',
    code_journeys: '',
  },
  {
    id_country: 219,
    name: 'Turkmenistn',
    code_nemo: 'TM',
    code_journeys: '',
  },
  {
    id_country: 220,
    name: 'Turqua',
    code_nemo: 'TR',
    code_journeys: '',
  },
  {
    id_country: 221,
    name: 'Tuvalu',
    code_nemo: 'TV',
    code_journeys: '',
  },
  {
    id_country: 222,
    name: 'Ucrania',
    code_nemo: 'UA',
    code_journeys: '',
  },
  {
    id_country: 223,
    name: 'Uganda',
    code_nemo: 'UG',
    code_journeys: '',
  },
  {
    id_country: 224,
    name: 'Uruguay',
    code_nemo: 'UY',
    code_journeys: '',
  },
  {
    id_country: 225,
    name: 'Vanuatu',
    code_nemo: 'VU',
    code_journeys: '',
  },
  {
    id_country: 226,
    name: 'Venezuela',
    code_nemo: 'VE',
    code_journeys: '',
  },
  {
    id_country: 227,
    name: 'Vietnam',
    code_nemo: 'VN',
    code_journeys: '',
  },
  {
    id_country: 228,
    name: 'Yamahiriya rabe Libia',
    code_nemo: 'LY',
    code_journeys: '',
  },
  {
    id_country: 229,
    name: 'Yemen, República de',
    code_nemo: 'YE',
    code_journeys: '',
  },
  {
    id_country: 230,
    name: 'Yibuti',
    code_nemo: 'DJ',
    code_journeys: '',
  },
  {
    id_country: 231,
    name: 'Yugoslavia',
    code_nemo: 'YU',
    code_journeys: '',
  },
  {
    id_country: 232,
    name: 'Zambia',
    code_nemo: 'ZM',
    code_journeys: '',
  },
  {
    id_country: 233,
    name: 'Zimbabue',
    code_nemo: 'ZW',
  },
];
